module.exports = __webpack_public_path__ + "img/analysis_magnify_screen.72b41397.svg";